// extracted by mini-css-extract-plugin
module.exports = {"provider-card-footer":"_1NsyHXagVmd_tu_ES4Nq6E"};